import { Component, Inject, Input, OnInit } from '@angular/core';
import { StoreService } from '../store.service';
import { Store } from '../store';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { map, shareReplay, tap } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { OnboardingDialogComponent } from '../onboarding-dialog/onboarding-dialog.component';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent implements OnInit {
  @Input() store: Store | undefined;
  isActive$: Observable<boolean> | undefined;
  paymentProvider = 'https://connect.stripe.com';
  title = 'Terminez votre adhésion';

  constructor(
    private readonly storeService: StoreService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.isActive$ = this.storeService.getOnboardingStatus().pipe(
      map((onboardingStatus) => onboardingStatus.active),
      tap((status) => this.openDialog(status)),
      shareReplay(1)
    );
  }

  redirectToOnboardingLink(): void {
    this.storeService
      .getOnboardingLink()
      .subscribe(
        (link) =>
          (this.document.location.href = this.paymentProvider + link.url)
      );
  }

  redirectToDashboardLink(): void {
    this.storeService
      .getDashboardLink()
      .subscribe(
        (link) =>
          (this.document.location.href = this.paymentProvider + link.url)
      );
  }

  openDialog(active: boolean): void {
    if (!active) {
      const dialogRef = this.dialog.open(OnboardingDialogComponent, {
        disableClose: false,
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.redirectToOnboardingLink();
        }
      });
    }
  }
}
